import React from 'react';
import { Button } from '@mentimeter/ragnar-ui/button';

interface BubbleProps {
  enabled: boolean;
  onToggle: (toggle: boolean) => void;
  mode: 'toggle' | 'hover';
}

export const QuickMaskBubble = ({ enabled, onToggle, mode }: BubbleProps) => (
  <Button
    variant="primary"
    onClick={() => mode === 'toggle' && onToggle(!enabled)}
    onMouseEnter={() => mode === 'hover' && onToggle(true)}
    onMouseLeave={() => mode === 'hover' && onToggle(false)}
    extend={({ theme }) => ({
      position: 'fixed',
      paddingLeft: '30px',
      left: '-20px',
      bottom: '144px',
      zIndex: 10000,

      height: '40px',
      width: '40px',
      borderRadius: `${theme.radii[3]}px`,
    })}
  >
    {enabled ? '❌' : '🎭'}
  </Button>
);
